import { ActiveTrial, ThermoImage, TrialType } from "../types";
import {
  isDateLikeSearchTerm,
  matchesDateFilter,
  matchesDateSearch
} from "./dateTime";

export type CalibrationSelection = "In Glass" | "On Glass";

export type TrialSelections = Record<TrialType, string[]>;

export type ThermoFilters = {
  date: string | null;
  calibration: CalibrationSelection | null;
  prodStep: string | null;
  trials: TrialSelections;
};

export const defaultFilters: ThermoFilters = {
  date: null,
  calibration: "On Glass",
  prodStep: null,
  trials: {
    Glaschemie: [],
    Brennstoff: [],
    "Energieverhältnis": [],
    Formgebung: []
  }
};

export function applyFilters(
  images: ThermoImage[],
  filters: ThermoFilters,
  searchTerm: string
): ThermoImage[] {
  const search = searchTerm.trim();
  const loweredSearch = search.toLowerCase();
  const searchIsDateLike = isDateLikeSearchTerm(search);

  return images.filter((img) => {
    if (search) {
      if (searchIsDateLike) {
        if (!matchesDateSearch(img.timestamp, search)) return false;
      } else {
        const haystack = `${img.filename} ${img.folder_name} ${img.prod_step}`.toLowerCase();
        if (!haystack.includes(loweredSearch)) return false;
      }
    }

    if (filters.date) {
      if (!matchesDateFilter(img.timestamp, filters.date)) {
        return false;
      }
    }

    if (filters.calibration && img.cal_name !== filters.calibration) {
      return false;
    }

    if (filters.prodStep && img.prod_step !== filters.prodStep) {
      return false;
    }

    if (!matchesTrialFilters(img.active_trials || [], filters.trials)) {
      return false;
    }

    return true;
  });
}

function matchesTrialFilters(activeTrials: ActiveTrial[], selections: TrialSelections) {
  const selectionEntries = Object.entries(selections) as [TrialType, string[]][];
  for (const [trialType, selectedNames] of selectionEntries) {
    if (!selectedNames.length) continue;
    const matchesGroup = activeTrials.some(
      (trial) =>
        trial.trial_type.toLowerCase() === trialType.toLowerCase() &&
        selectedNames.includes(trial.descriptive_name)
    );
    if (!matchesGroup) return false;
  }
  return true;
}
